// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1BDW9","inputs":"styles_inputs__V9uCY","checkboxes":"styles_checkboxes__1Wg_C"};